import React, { useState, useEffect,useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  Typography,
  Stack,
  IconButton,
  Tabs,
  Tab,
  DialogContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Grid,
  Autocomplete,
  DialogActions,
  Button,Divider
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { locationsSelector } from "../../../../../store/slices/location";
import _ from 'lodash'
import { deleteFacts,updateFacts } from "../../../../../store/slices/facts";
const factsLimit=4000
const EditFact = ({ open, setOpen, fact,companyId,reviewId,openWarning,setOpenWarning }) => {
    const dispatch=useDispatch()
  const [factValue, setFactValue] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const {brands,regions,locations}=useSelector(locationsSelector)
  const [radioValue, setRadioValue] = useState("location");
  const [locationValue, setLocationValue] = useState([]);
  const [brandsValue, setBrandsValue] = useState([]);
  const [regionsValue, setRegionsValue] = useState([]);
  const {entityIds,entityType}=fact
  const locationsList = React.useMemo(() => {
    let dataList = [];

    if (locations) {
      _.map(locations, (location) => {
        let data = { value: location.locationId, label: location.name };
        dataList.push(data);
      });
    }

    return (dataList = _.uniqBy(dataList, "value"));
  }, [locations]);

  const brandsList = useMemo(() => {
    return _.map(brands, (it) => ({ value: it?.brandId, label: it?.name }));
  }, [brands]);
  const regionsList = useMemo(() => {
    return _.map(regions, (it) => ({ value: it?.regionId, label: it?.name }));
  }, [regions]);

  useEffect(() => {
    setRadioValue(entityType?_.lowerCase(entityType):'location')
    if(entityIds){
      if(entityType==='Location'){
        setLocationValue(_.map(entityIds,it=>{
          const selectedLocation=_.find(locationsList,item=>item.value===it)
          return selectedLocation
        }))
      }
      if(entityType==='Region'){
       
       const temp=_.map(entityIds,it=>{
        const selectedLocation=_.find(regionsList,item=>item.value===it)
        // debugger
        return selectedLocation
      })
        setRegionsValue(temp)
      }
      if(entityType==='Brand'){
        setBrandsValue(_.map(entityIds,it=>{
          const selectedLocation=_.find(brandsList,item=>item.value===it)
          return selectedLocation
        }))
      }
    }
    // setLocationValue(
    //   fact?.locationId
    //     ? _.find(locationsList, (it) => it.value === fact?.locationId)
    //     : { label: "All", value: "all" }
    // );
    setFactValue(fact?.fact);
  }, [fact]);
  const onClose = () => {
    setOpen(false);
  };
  const handleTabs = (event, newValue) => {
    setTabValue(newValue);
  };
 
  const onSave = () => {
    if (factValue?.length > 0 && factValue?.length <= factsLimit) {
    const entityTypeIds =
    (_.size(locationValue) > 0 ||
    _.size(brandsValue) > 0 ||
    _.size(regionsValue) > 0)
      ? radioValue === "location"
        ? _.map(locationValue, (it) => it.value)
        : radioValue === "brand"
        ? _.map(brandsValue, (it) => it.value)
        : radioValue === "region"
        ? _.map(regionsValue, (it) => it.value)
        : null
      : null;
    let data = {
        factId: fact.factId,
        fact: factValue,
        entityType: _.startCase(radioValue),
        entityIds: entityTypeIds,
        companyId: companyId,
      };
      dispatch(updateFacts(data,reviewId));
      onClose();}
  };
  const onDelete=()=>{
dispatch(deleteFacts(fact?.factId,reviewId))
setOpenWarning(false)
onClose()
  }

  return (
    <>
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5">Edit Fact</Typography>
          <IconButton color="secondary" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>

        {/* <Tabs
          value={tabValue}
          onChange={handleTabs}
          sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
        >
          <Tab label="Fact Details" value={0} />
          <Tab label="Remove fact" value={1} />
        </Tabs> */}
      </DialogTitle>
      <DialogContent sx={{ p: 4, display:'flex',justifyContent:'center',alignItems:'center' }}>
        { (
          <Grid columns={6} container spacing={3} sx={{ pt: 2, px: 1 }}>
            <Grid item xs={1} sx={{alignItems:'center',display:'flex'}}>
            <Typography variant="subtitle1">Append with</Typography>
          </Grid>
          <Grid item xs={5}>
            <RadioGroup
              aria-labelledby="append-with-radio-group-label"
              // defaultValue="location"
              name="append-with-group"
              row
              value={radioValue}
              onChange={(e) => setRadioValue(e.target.value)}
              size="small"
            >
              <FormControlLabel
                size="small"
                value="location"
                control={<Radio size="small" />}
                label="Locations"
              />
              <FormControlLabel
                size="small"
                value="brand"
                control={<Radio size="small" />}
                label="Brands"
              />
              <FormControlLabel
                size="small"
                value="region"
                control={<Radio size="small" />}
                label="Regions"
              />
            </RadioGroup>
          </Grid>
          {radioValue === "location" && (
            <>
              <Grid item xs={1} sx={{alignItems:'center',display:'flex'}}>
                <Typography variant="subtitle1">Location</Typography>
              </Grid>
              <Grid item xs={5}>
                <Autocomplete
                  multiple
                  fullWidth
                  disableCloseOnSelect
                  value={locationValue}
                  limitTags={3}
                  id="tags-standard"
                  options={locationsList}
                  onChange={(e, newValue) => setLocationValue(newValue)}
                  getOptionLabel={(option) => option?.label}
                  // defaultValue={[top100Films[13]]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // variant="standard"

                      placeholder="Search"
                    />
                  )}
                />
              </Grid>
            </>
          )}
          {radioValue === "brand" && (
            <>
              <Grid item xs={1} sx={{alignItems:'center',display:'flex'}}>
                <Typography variant="subtitle1">Brands</Typography>
              </Grid>
              <Grid item xs={5}>
                <Autocomplete
                  multiple
                  fullWidth
                  disableCloseOnSelect
                  limitTags={3}
                  value={brandsValue}
                  id="tags-standard"
                  options={brandsList}
                  onChange={(e, newValue) => setBrandsValue(newValue)}
                  getOptionLabel={(option) => option?.label}
                  // defaultValue={[top100Films[13]]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // variant="standard"

                      placeholder="Search"
                    />
                  )}
                />
              </Grid>
            </>
          )}
          {radioValue === "region" && (
            <>
              <Grid item xs={1} sx={{alignItems:'center',display:'flex'}}>
                <Typography variant="subtitle1">Regions</Typography>
              </Grid>
              <Grid item xs={5}>
                <Autocomplete
                  multiple
                  fullWidth
                  disableCloseOnSelect
                  value={regionsValue??''}
                  limitTags={3}
                  id="tags-standard"
                  options={regionsList}
                  onChange={(e, newValue) => setRegionsValue(newValue)}
                  getOptionLabel={(option) => option?.label}
                  // defaultValue={[top100Films[13]]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // variant="standard"

                      placeholder="Search"
                    />
                  )}
                />
              </Grid>
            </>
          )}
            <Grid item xs={1}>
              <Typography variant="subtitle1">Fact</Typography>
            </Grid>
            <Grid item xs={5}>
              <TextField
                value={factValue}
                onChange={(e) => setFactValue(e.target.value)}
                multiline
                rows={6}
                fullWidth
                inputProps={{ maxLength: factsLimit }}
                error={
                  factValue?.length >= factsLimit ||
                  (factValue?.length === 0)
                }
              />
              {factValue?.length >= factsLimit && (
                <Typography
                  sx={{ position: "absolute" }}
                  vairant="caption"
                  color={"error"}
                >
                  Facts Should not be more than {factsLimit} words!
                </Typography>
              )}
            </Grid>
          </Grid>
        )}
        {/* {tabValue===1&&(
            <Button variant='outlined' color='error' onClick={onDelete}>Remove Fact</Button>
        )} */}
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mx: 3,
          pb: 3,
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
          position: "relative",
        }}
      >
        <Stack direction='row' spacing={2}>

        <Button variant="contained" sx={{ width: "140px" }} onClick={onSave} disabled={tabValue===1}>
          Save
        </Button>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
        </Stack>
        {/* <Box flewGrow={1}/> */}
        <Button variant='outlined' color='error' onClick={()=>setOpenWarning(true)} sx={{justifySelf:'end'}}>Delete</Button>
      </DialogActions>
    </Dialog>
    {openWarning&&<Dialog open={openWarning}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <Divider />
          <DialogContent>
            Are you sure you want to delete this fact?
          </DialogContent>
          <Divider />
          <DialogActions
            sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
          >
            <Button
              onClick={onDelete}
              variant="contained"
              size="small"
              color="error"
            >
              Delete
            </Button>
            <Button
              onClick={() => setOpenWarning(false)}
              size="small"
              variant="outlined"
              color="primary"
              sx={{ ml: 2 }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>}
    </>
  );
};

export default EditFact;
